module.exports = __webpack_public_path__ + "static/media/corgan.49a50839.png";